// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableClass {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  .thClass{\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: left;\n  }\n ", ""]);
// Exports
module.exports = exports;
